<template>
  <el-dialog
    title="导出客服信息"
    :visible.sync="visibleDialog"
    width="520px"
    top="calc(50vh - 150px)"
    class="pop-dialog pop-import"
    append-to-body>
    <div class="import-con" >
      <div class="tips">请使用导入模版，填写手机号上传并点击【确认】，会自动导出相关客服信息。</div>
      <el-upload ref="tops" class="upload-con" accept=".doc,.docx,.xls,.xlsx,.csv" drag action="#"
          :multiple="false" :http-request="orderImport" :limit="1" v-loading="loading" element-loading-text="导出中">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
          </div>
      </el-upload>
  </div>
  <div class="dialog-footer">
      <div @click="downloadlink(link)">
          <el-button type="text" size="mini" icon="el-icon-download">导入模板下载</el-button>
      </div>
      <div>
          <el-button @click="visibleDialog = false" size="mini">取 消</el-button>
          <el-button type="primary" @click="onConfirm" size="mini" :loading="loading">确 定</el-button>
      </div>                                                                                                                                                                                                                                                                                                                                                                                                                                     
  </div>
</el-dialog>
</template>
<script>
  export default {
    name:'popImport',
    data () {
      return {
        visibleDialog:false,
        loading:false,
        file: '',
        link:'https://fenxiao.muruji.com/d840a069177d4e41aa549a2ee9996f63.xlsx'
      }
    },
    
    methods: {
      show() {
        this.file = ''
        this.visibleDialog = true
        this.$nextTick(() => {
            this.$refs['tops'].clearFiles()
        })
      },
       orderImport(fileObj) {
        this.file = fileObj.file
      },
      onConfirm() {
          if (!this.file) {
              this.$message.warning('请选择文件')
              return
          }
          console.log('>>',this.file)
          const formData = new FormData()
          this.loading = true
          formData.append('file', this.file)
          this.$api.customerExport(formData).then((res) => {
              if (res.code == 0 &&  res.data &&  res.data.downloadUrl) {
                  this.$message.success('操作成功')
                  this.visibleDialog = false
                  let url = res.data.downloadUrl
                  // 上传后，自动下载文件
                   this.downloadlink(url)
              }
          }).finally(() => {
              this.loading = false
          })
      },
    },
  }
</script>
<style lang='scss'>
.pop-import{
  .import-con{
    padding: 20px 0;
  }
  .tips{
    font-size: 12px;
    color: #7F7F7F;
    height: 27px;
    line-height: 17px;
  }
  .upload-con .el-upload-dragger{
    width: 480px;
    height: 120px;
    border-radius: 0;
     .el-icon-upload{
      margin: 20px 0 0;
      font-size: 40px;
      color: #B3BACB;
     }
     .el-upload__text{
      font-size: 12px;
     }
  }
  .el-upload-list__item{
    font-size: 12px;
    line-height: 25px;
    .el-icon-close{
      font-size: 16px;
    }
  }
  .dialog-footer{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .el-button--text{
      font-weight: normal;
    }
  }
}
</style>